import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Case {
    id: string;
    data: any; // Replace 'any' with your actual case data type
}

interface BulkUploadState {
    cases: Case[];
}

const initialState: BulkUploadState = {
    cases: [],
};

const bulkUploadSlice = createSlice({
    name: 'bulkUpload',
    initialState,
    reducers: {
        saveMultipleCases(state, action: PayloadAction<Case[]>) {
            state.cases = [...state.cases, ...action.payload];
        },
        clearCases(state) {
            state.cases = [];
        },
    },
});

export const { saveMultipleCases, clearCases } = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;